<template>
    <div>
        <!-- INTRO -->
        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="light-blue pa-5 white--text">
                    <p style="font-size: xx-large; font-weight: 350; font-style: italic;">
                        {{$t("rooms.breakfast")}}
                    </p>
                    <p class="sub-intro" style="font-style: italic;">
                        {{$t("rooms.breakfast_details")}}
                    </p>
                </v-flex>
            </v-layout>
        </section>

        <!-- FIRST -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6>
                    <img :src="getImageUrl('cibo/colazione_1.jpeg')" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{ $t("breakfast.box1") }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- SECOND -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{ $t("breakfast.box2") }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
                    <img :src="getImageUrl('cibo/colazione_5.jpeg')" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- THIRD -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6>
                    <img :src="getImageUrl('cibo/colazione_6.jpeg')" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{ $t("breakfast.box3") }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    methods: {
      getImageUrl: function(image){
        return require(`../assets/img/${image}`);
      }
    }
}
</script>

<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }

    .my-headline{
        font-size: xx-large;
        font-weight: 300;
        font-style: italic;
    }

    .mybg{
        background-color: var(--v-warning-darken1);
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
        max-height: 506px;
    }
</style>
